export function isValidURL(url: string) {
  let transformedURL: URL | undefined

  try {
    transformedURL = new URL(url)
  } catch {
    return false
  }

  return (
    transformedURL.protocol === "http:" ||
    transformedURL.protocol === "https:" ||
    transformedURL.protocol === "mailto:"
  )
}
